<template>
    <div>
        <h3>Nieuw WPBR-pas aanvragen</h3>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="firstName">Betreft <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12" >
                <select class="form-control bg-light" v-model="form.request">
                    <option :value="1">1e Aanvraag</option>
                    <option :value="2">Verlenging</option>
                    <option :value="3">Vervanging (bij diefstal of verlies)</option>
                </select>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="firstName">Functie <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12" >
                <select class="form-control bg-light" v-model="form.function">
                    <option value="Beveiliger (grijs)">Beveiliger (grijs)</option>
                    <option value="Beveiliger-Winkelsurveillant (grijs)">Beveiliger-Winkelsurveillant (grijs)</option>
                    <option value="Beveiliger-Persoonsbeveiliger (grijs)">Beveiliger-Persoonsbeveiliger (grijs)</option>
                    <option value="Beveiliger-Winkelsurveillant-Persoonsbeveiliger (grijs)">Beveiliger-Winkelsurveillant-Persoonsbeveiliger (grijs)</option>
                    <option value="Beveiliger in opleiding (groen)">Beveiliger in opleiding (groen)</option>
                    <option value="Event Security Officer (blauw)">Event Security Officer (blauw)</option>
                    <option value="Event Security Officer in opleiding (groen)">Event Security Officer in opleiding (groen)</option>
                    <option value="Horecaportier (blauw)">Horecaportier (blauw)</option>
                    <option value="Voetbalsteward (oranje)">Voetbalsteward (oranje)</option>
                </select>
            </div>
        </div>
        <h4>Regels</h4>
        <ul>
            <li>De pas is uitsluitend te gebruiken voor opdrachten van Azurity Beveiliging;</li>
            <li>De pas is eigendom van Azurity Beveiliging;</li>
            <li>U bent verantwoordelijk voor de juistheid van de onderstaande gegevens;</li>
            <li>Stuur een duidelijke pasfoto, legitimatie en handtekening mee (zie voorbeelden);</li>
            <li>Voor de pas wordt eenmalig 344 credits (€ 86,-) aan leges kosten in rekening gebracht;</li>
            <li>Na minimaal 40 uur aan declarabele werkzaamheden, vergoeden wij de leges kosten;</li>
        </ul>
        <div class=" text-md-right">
            <loader v-if="isLoading" width="3rem"></loader>
            <div v-else>
                <div class="row">
                    <div class="col-md-6 text-md-left text-center">
                        <p>
                            U heeft nog <strong>{{$store.getters.credits}}</strong> credits.
                            <br/><small><strong>1 pasaanvraag = 344 credits.</strong></small>
                            <br /><small class="red" v-if="$store.getters.credits < 344">U heeft onvoldoende tegoed. <router-link tag="a" :to="{ name: 'ProfessionalProfileCredits' }">Opwaarderen!</router-link></small>
                        </p>
                    </div>
                    <div class="col-md-6 text-md-right text-center">
                        <button :class="['btn btn-lg', $v.$invalid || $store.getters.credits < 344 ? 'btn-outline-azure-dark' : 'btn-azure-dark']" @click="send" :disabled="$v.$invalid || $store.getters.credits < 344">
                            <font-awesome-icon icon="save" class="mr-2"></font-awesome-icon>Pas Aanvragen
                        </button>
                        <br />
                        <small v-if="$v.$invalid" class="red">Niet alle onderstaande gegevens zijn juist ingevuld. <router-link v-if="$store.getters.credits < 344" tag="a" :to="{ name: 'ProfessionalProfileCredits' }">Opwaarderen!</router-link></small>
                    </div>
                </div>
            </div>
        </div>

        <hr class="mt-4 mb-4" />

        <div class="row text-center" v-if="!$parent.isLoading">
            <div class="col-md-6 mb-5" >
                <h5>Pasfoto <sup class="red" title="verplicht">*</sup></h5>
                <picture-input :class="[($v.passPhoto.$error) ? 'is-invalid' : ($v.passPhoto.$dirty) ? 'is-valid' : '']"
                    ref="pictureInput"
                    width="276" 
                    height="355" 
                    margin="0" 
                    radius="0"
                    accept="image/jpeg,image/png" 
                    size="2" 
                    button-class="btn"
                    :prefill="prefillImage"
                    :zIndex="0"
                    :hideChangeButton="true"
                    :custom-strings="{
                        upload: '<h1>Oeps!</h1>',
                        drag: 'Klik of sleep hier uw pasfoto'
                    }"
                    @change="onSetPhoto">
                </picture-input>  
                <div class="text-center">              
                    <small class="text-center"><strong><a href="/img/pasfoto_afmetingen.png" download="pasfoto_afmetingen.png" target="_blank">Download hier!</a></strong> Voorbeeld afmetingen.</small>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="label" for="nationality"><h5>Kopie Legitimatie <sup class="red" title="verplicht">*</sup></h5></label>
                    <div class="control">
                        <div class="input-group">
                            <div class="custom-file text-left">
                                <input :class="['custom-file-input', ($v.identity.$dirty) ? ($v.identity.$error) ?'is-invalid' : 'is-valid' : '']" type="file" name="identity" id="identity" @change="onSetFile">
                                <label class="custom-file-label ellipsis" for="identity">{{(identity == null) ? 'Kies bestand...' : identity.name}}</label>
                            </div>
                        </div>
                        <small><strong>Let op!</strong> Maak het BSN-nummer onleesbaar.</small>
                    </div>
                </div>
                
                <h5>Handtekening <sup class="red" title="verplicht">*</sup></h5>
                <picture-input :class="[($v.signature.$error) ? 'is-invalid' : ($v.signature.$dirty) ? 'is-valid' : '']"
                    ref="pictureInput"
                    width="354" 
                    height="108" 
                    margin="0" 
                    radius="0"
                    accept="image/jpeg,image/png" 
                    size="2" 
                    button-class="btn"
                    :prefill="prefillSignature"
                    :zIndex="0"
                    :hideChangeButton="true"
                    :custom-strings="{
                        upload: '<h1>Oeps!</h1>',
                        drag: 'Klik of sleep hier uw handtekening'
                    }"
                    @change="onSetSignature">
                </picture-input>     
                <div class="text-center">                   
                    <small ><strong><a href="/img/handtekening_afmetingen.png" download="handtekening_afmetingen.png" target="_blank">Download hier!</a></strong> Voorbeeld afmetingen.</small>
                </div>
            </div>
        </div>

        <hr class="mb-4" />

        <h3>Controleer de onderstaande gegevens</h3>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="firstName">Voornaam <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12" >
                <input :class="['form-control bg-light', ($v.form.firstName.$dirty) ? ($v.form.firstName.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Voornaam" v-model="form.firstName" name="firstName" id="firstName">
                <div class="invalid-feedback">
                    Voornaam is verplicht met minimaal 2 karakters.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="lastName">Achternaam <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12">
                <input :class="['form-control bg-light', ($v.form.lastName.$dirty) ? ($v.form.lastName.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Achternaam" v-model="form.lastName" name="lastName" id="lastName">
                <div class="invalid-feedback">
                    Achternaam is verplicht met minimaal 2 karakters.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="street">Straat + Huisnummer <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12">
                <input :class="['form-control bg-light', ($v.form.address.$dirty) ? ($v.form.address.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Straat + Huisnummer" v-model="form.address" name="address" id="address">
                <div class="invalid-feedback">
                    Adres is verplicht. Het adres moet een straatnaam en huisnummer bevatten.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="postalCode">Postcode <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12">
                <input :class="['form-control bg-light', ($v.form.postalCode.$dirty) ? ($v.form.postalCode.$error) ?'is-invalid' : 'is-valid' : '']"  type="text" placeholder="1234 XX" v-model.trim="form.postalCode" name="postalCode" id="postalCode" @change="form.postalCode = form.postalCode.toUpperCase()">
                <div class="invalid-feedback">
                    Postcode is verplicht. Postcode moet het formaat 1234 XX hebben.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="city">Plaats <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12">
                <v-select label="name" :filterable="false" :options="$store.getters.cities" @search="onSearchCity" v-model="form.city" :class="['form-control bg-light', ($v.form.city.$dirty) ? ($v.form.city.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="Plaats" name="city" id="city"  @change="$v.form.city.$touch">
                    <template slot="no-options">
                        Zoek een plaats...
                    </template>
                    <template slot="option" slot-scope="option" class="m-0 p-0">
                        <div class="d-center m-0 p-0" >
                            {{ option.name }}
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center ellipsis">
                            {{ option.name }}
                        </div>
                    </template>
                </v-select><div class="invalid-feedback">
                    Plaatsnaam is verplicht.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="phoneNumber">Telefoonnummer (Privé) <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12">
                <input :class="['form-control bg-light', ($v.form.phoneNumber.$dirty) ? ($v.form.phoneNumber.$error) ?'is-invalid' : 'is-valid' : '']" type="tel" placeholder="06" v-model.trim="form.phoneNumber" name="phoneNumber" id="phoneNumber">
                <div class="invalid-feedback">
                    Telefoonnummer is verplicht. Het nummer moet beginnen met 06 of 0031.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="phoneNumber">Telefoonnummer (Werk) </label>
            <div class="control col-md-8 col-12">
                <input :class="['form-control bg-light', ($v.form.phoneNumberWork.$dirty) ? ($v.form.phoneNumberWork.$error) ?'is-invalid' : 'is-valid' : '']" type="tel" placeholder="06" v-model.trim="form.phoneNumberWork" name="phoneNumberWork" id="phoneNumberWork">
                <div class="invalid-feedback">
                    Het nummer moet beginnen met 06 of 0031.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="phoneNumber">Email <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12">
                <input :class="['form-control bg-light', ($v.form.email.$dirty) ? ($v.form.email.$error) ?'is-invalid' : 'is-valid' : '']" type="email" v-model.trim="form.email" name="email" id="email">
                <div class="invalid-feedback">
                    Ongeldig email adres.
                </div>
            </div>
        </div>
        
        <hr class="mt-4 mb-4" />

        <div class="form-group row">
            <label class="label col-md-4 col-12" for="phoneNumber">Geboortedatum <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12">
                <input :class="['form-control bg-light', ($v.form.dateOfBirth.$dirty) ? ($v.form.dateOfBirth.$error) ?'is-invalid' : 'is-valid' : '']" type="date" v-model.trim="form.dateOfBirth" name="dateOfBirth" id="dateOfBirth">
                <div class="invalid-feedback">
                    Geboortedatum is verplicht. Minimaal 18 jaar.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="phoneNumber">Geboorteland <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12">
                <input :class="['form-control bg-light', ($v.form.countryOfBirth.$dirty) ? ($v.form.countryOfBirth.$error) ?'is-invalid' : 'is-valid' : '']" type="text" v-model.trim="form.countryOfBirth" name="countryOfBirth" id="countryOfBirth">
                <div class="invalid-feedback">
                    Geboorteland is verplicht.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="phoneNumber">Geboorteplaats <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12">
                <v-select label="name" :filterable="false" :options="$store.getters.cities" @search="onSearchCity" v-model="form.cityOfBirth" :class="['form-control bg-light', ($v.form.cityOfBirth.$dirty) ? ($v.form.cityOfBirth.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="Geboorteplaats" name="cityOfBirth" id="cityOfBirth"  @change="$v.form.cityOfBirth.$touch">
                    <template slot="no-options">
                        Zoek een plaats...
                    </template>
                    <template slot="option" slot-scope="option" class="m-0 p-0">
                        <div class="d-center m-0 p-0" >
                            {{ option.name }}
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                            {{ option.name }}
                        </div>
                    </template>
                </v-select><div class="invalid-feedback">
                    Geboorteplaats is verplicht.
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="label col-md-4 col-12" for="nationality">Nationaliteit <sup class="red" title="verplicht">*</sup></label>
            <div class="control col-md-8 col-12">
                <input :class="['form-control bg-light', ($v.form.nationality.$dirty) ? ($v.form.nationality.$error) ?'is-invalid' : 'is-valid' : '']" type="text"  v-model.trim="form.nationality" name="nationality" id="nationality">
                <div class="invalid-feedback">
                    Nationaliteit is verplicht.
                </div>
            </div>
        </div>
        
        <div class="form-group text-md-right text-center">
            <loader v-if="isLoading" width="3rem"></loader>
            <div v-else>
                <button :class="['btn btn-lg', $v.$invalid || $store.getters.credits < 344 ? 'btn-outline-azure-dark' : 'btn-azure-dark']" @click="send" :disabled="$v.$invalid || $store.getters.credits < 344">
                    <font-awesome-icon icon="save" class="mr-2"></font-awesome-icon>Pas Aanvragen
                </button>
                <br />
                <small v-if="$v.$invalid" class="red">Niet alle bovenstaande gegevens zijn juist ingevuld.</small>
            </div>
        </div>
        
        <vue-toastr ref="toastr"></vue-toastr>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import vSelect from 'vue-select';
import VueToastr from "vue-toastr";
import globalFunctions from '@/mixins/globalFunctions'
import { required, email, url, or } from 'vuelidate/lib/validators'
import { mobile, landline, address, postalcode, fileValidation, isDate } from '@/mixins/validations'
import Loader from '@/components/Loader'
import PictureInput from 'vue-picture-input'

export default {
    name: 'PassRequest',
    mixins: [validationMixin, globalFunctions],
    components: {
        Loader,
        PictureInput,
        VueToastr,
        vSelect
    },
    data() {
        return {
            isLoading: false,
            prefillImage: '',
            prefillSignature: '',
            passPhoto: null,
            identity: null,
            signature: null,
            intervalId: null,
            form: {
                firstName: null,
                lastName: null,
                phoneNumber: null,
                phoneNumberWork: null,
                dateOfBirth: null,
                cityOfBirth: null,
                countryOfBirth: null,
                nationality: null,
                address: null,
                postalCode: null,
                city: null,
                email: null,
                isBoa: false,
                isBoaSince: null,
                isBoaDescription: null,
                request: 1,
                function: "Beveiliger (grijs)"
            }
        }
    },
    validations: {
        form: {
            firstName: 
            {
                required
            },
            lastName: 
            {
                required
            },
            phoneNumber: 
            {
                required,
                or: or(mobile, landline)
            },
            phoneNumberWork: {

            },
            email: {
                required,
                email
            },
            dateOfBirth: 
            {
                required,
                isDate
            },
            cityOfBirth: 
            {
                required
            },
            countryOfBirth: 
            {
                required
            },
            nationality: 
            {
                required
            },
            address: 
            {
                required,
                address
            },
            postalCode: 
            {
                required,
                postalcode
            },
            city: 
            {
                required
            }
        },
        passPhoto: 
        {
            required,
            fileValidation
        },
        signature: 
        {
            required,
            fileValidation
        },
        identity: 
        {
            required,
            fileValidation
        }
    },
    mounted() {
        this.$refs.toastr.defaultPosition = "toast-bottom-right";
        this.get();
        this.$store.dispatch("GET_CREDITS");
    },
    methods: {
        onSearchCity(search, loading) {
            this.$store.dispatch('GET_CITIES', { search, loading });
        }, 
        get() {
            this.isLoading = true;
            this.$http.get('api/Pass/WPBR/User').then((res) => {
                let date = new Date(res.data.dateOfBirth);
                res.data.dateOfBirth = date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + (date.getDate())).slice(-2);

                this.form = res.data;
                this.isLoading = false;
                this.$v.$touch();
            })
        },
        onSetPhoto (image) {
            if (image) {
                var type = image.substring(image.indexOf(":") + 1, image.indexOf(";"));
                this.passPhoto = this.b64ToFile(image.split(',')[1], type, 'passphoto.' + type.split("/")[1]);
            }
        },
        onSetSignature (image) {
            if (image) {
                var type = image.substring(image.indexOf(":") + 1, image.indexOf(";"));
                this.signature = this.b64ToFile(image.split(',')[1], type, 'signature.' + type.split("/")[1]);
            }
        },
        onSetFile(ev)
        {
            var file = ev.currentTarget.files[0];
            this[ev.currentTarget.name] = file;
        },
        send() {
            this.$v.$touch();
            if(!this.$v.$invalid)
            {
                let formData = new FormData();
                formData.append("form", JSON.stringify(this.form));
                formData.append("passPhoto", this.passPhoto);
                formData.append("identity", this.identity);
                formData.append("signature", this.signature);

                this.isLoading = true;
                this.$http.post('api/Pass/WPBR/', formData).then((res) => 
                {
                    this.$store.dispatch("GET_CREDITS");
                    this.$refs.toastr.s("We hebben uw aanvraag verstuurd!");
                    this.isLoading = false;
                }).catch(() => {
                    this.$refs.toastr.e("Helaas is er iets fout gegaan. Probeer nogmaals.");
                })
            };
        }
    }
}
</script>

<style scoped lang="scss">
/deep/.picture-input  
{
    &.is-invalid {
        .preview-container {
            border: 2px solid #dc3545 !important;
        }
    }
    &.is-valid {
        .preview-container
        {
            border: 2px solid #28a745 !important;
        }
    }
    .picture-inner .picture-inner-text {
        font-size: 1rem;
    }
}
.picture-input.is-valid .preview-container
{
    border: 2px solid #28a745 !important;
}

</style>